"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeFilters = exports.sanitizeFilter = exports.deleteSavedSearchToFilterItems = exports.addSavedSearchToFilterItems = exports.getDisplayedFilterValue = exports.formatFilterDate = exports.getSections = exports.defaultSection = exports.firstOrAmountSelected = exports.hasProperties = void 0;
const lodash_1 = require("lodash");
const luxon_1 = require("luxon");
const constants_1 = require("../../constants");
const hasProperties = ({ filters }) => !!Object.keys(filters).filter((filterKey) => !!filters[filterKey]).length;
exports.hasProperties = hasProperties;
const firstOrAmountSelected = (elements) => elements.length > 1 ? `${elements.length} selected` : `${elements[0]}`;
exports.firstOrAmountSelected = firstOrAmountSelected;
exports.defaultSection = {
    id: constants_1.SAVED_SEARCHES_SECTION_ID,
    name: "Saved Searches",
};
const getSections = (config, defaults = [exports.defaultSection]) => defaults.concat(Object.entries(config)
    .filter(([, filter]) => (0, lodash_1.isObject)(filter) && (0, exports.hasProperties)(filter))
    .map(([categoryId, { categoryLabel }]) => ({
    id: categoryId,
    name: categoryLabel,
})));
exports.getSections = getSections;
const formatFilterDate = (date) => date.toLocaleString(luxon_1.DateTime.DATE_SHORT);
exports.formatFilterDate = formatFilterDate;
const getDisplayedFilterValue = (value) => {
    if ((0, lodash_1.isObject)(value)) {
        if (luxon_1.DateTime.isDateTime(value)) {
            return (0, exports.formatFilterDate)(value);
        }
        if (value?.length) {
            return (0, exports.firstOrAmountSelected)(value);
        }
    }
    return value?.toString() || "";
};
exports.getDisplayedFilterValue = getDisplayedFilterValue;
const addSavedSearchToFilterItems = (savedSearch, filterItems) => filterItems.map(({ items, id, ...item }) => ({
    ...item,
    id,
    items: id === constants_1.AdvancedSearchType.UserSaved
        ? [
            ...items,
            {
                ...savedSearch,
                type: constants_1.AdvancedSearchFilterOptionType.SavedSearch,
                viewableByAll: savedSearch.scope === constants_1.Scope.Global,
            },
        ]
        : items,
}));
exports.addSavedSearchToFilterItems = addSavedSearchToFilterItems;
const deleteSavedSearchToFilterItems = (filterItems, itemId) => filterItems.map(({ items, ...filter }) => ({
    ...filter,
    items: filter.id === constants_1.AdvancedSearchType.UserSaved
        ? items.filter(({ id }) => id !== itemId)
        : items,
}));
exports.deleteSavedSearchToFilterItems = deleteSavedSearchToFilterItems;
const sanitizeFilter = ({ path, operator, category, value, subjects, context, }) => ({
    path,
    operator,
    category,
    value,
    subjects,
    context,
});
exports.sanitizeFilter = sanitizeFilter;
const sanitizeFilters = (filters) => filters.map(exports.sanitizeFilter);
exports.sanitizeFilters = sanitizeFilters;
